import { useEffect, useState } from 'react';
import { ReportsServicesRpsb, RPSB } from '../../../services/api/reports/ReportsServicesRpsb';
import { useNavigate, useParams } from 'react-router-dom';
import { LayoutBase } from '../../../layouts';
import { ToolsDamInformation } from '../../../components/custom';
import { Box, Button, Divider, IconButton, LinearProgress, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material';
import { Add, ArrowCircleLeft, ArrowCircleRight, Remove, SaveRounded } from '@mui/icons-material';
import { useForm, useFieldArray } from 'react-hook-form';
import { CustomAlert } from '../../../components/shared';
import Recomendacoes from '../../../components/custom/Reports/Rpsb/Recomendacoes';

const steps = ['Geral', 'Análise', 'Verificação', 'Recomendação', 'Avaliação'];

export default function RegisterReportsRpsb() {

    const { rpsb, id } = useParams();
    const navigate = useNavigate();
    const defaultValues: RPSB = {
        id_barragem: '',
        periodo_referencia: '',
        empresa_executora: '',
        data_inspecao: '',
        data_dce: null,
        status_dce: '',
        responsavel: '',
        art: '',
        orgao: '',
        dpa: '',
        cri: '',
        classificacao: '',
        verificacaoHidrologica: {
            area_drenagem: '',
            precipitacao_pmp: '',
            precipitacao_projeto: '',
            duracao_chuva: '',
            vazao_maxima: '',
            na_maximo_operacional: '',
            na_maximo_maximorum: '',
            borda_livre: '',
            bombeamento: '',
        },
        avaliacoes: [],
        recomendacoes: [],
        analiseEstabilidade: {
            informacoes: [],
            metodo_analise: '',
            modos_falha: '',
        },
    };

    const [loading, setLoading] = useState<boolean>(true);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success',
    });

    useEffect(() => {
        if (rpsb !== 'new' && rpsb) {
            fetchData(rpsb);
        } else {
            setLoading(false);
            setValue('id_barragem', id);
        }
    }, []);

    const handleSend = async (data: RPSB) => {
        if (rpsb && rpsb !== 'new') {
            try {
                data.data_dce === '' ? data.data_dce = null : data.data_dce;
                const res = await ReportsServicesRpsb.upgrade(data, rpsb);
                if (res instanceof Error) {
                    setAlertInfo({ open: true, message: `Erro ao atualizar !: ${res.name}`, severity: 'warning' });
                } else {
                    setAlertInfo({ open: true, message: 'Registro atualizar !', severity: 'success' });
                    setTimeout(() => {
                        navigate(-1);
                    }, 1000);
                }
            } catch (error) {
                setAlertInfo({ open: true, message: 'Erro ao atualizar !', severity: 'warning' });
            }
        } else {
            try {
                data.data_dce === '' ? data.data_dce = null : data.data_dce;
                const res = await ReportsServicesRpsb.create(data);
                if (res instanceof Error) {
                    setAlertInfo({ open: true, message: `Erro ao cadastrar !: ${res.name}`, severity: 'warning' });
                } else {
                    setAlertInfo({ open: true, message: 'Registro salvo !', severity: 'success' });
                    setTimeout(() => {
                        navigate(-1);
                    }, 1000);
                }
            } catch (error) {
                setAlertInfo({ open: true, message: 'Erro ao cadastrar !', severity: 'warning' });
            }
        }
    };

    //Controle de stepper
    type FormSchema = RPSB;
    const { register, handleSubmit, formState, control, setValue, getValues, reset } = useForm<FormSchema>({ defaultValues });
    const { fields, append, remove } = useFieldArray({ control, name: 'analiseEstabilidade.informacoes' });
    const { fields: avaliacoesFields, append: appendAvaliacao, remove: removeAvaliacao } = useFieldArray({ control, name: 'avaliacoes' });

    const [stepAtivo, setStepAtivo] = useState<number>(0);

    async function fetchData(uuid_rpsb: string) {
        const res = await ReportsServicesRpsb.get(uuid_rpsb);
        if (res instanceof Error) {
            alert('Erro ao buscar RPSB');
        } else {
            const response = res as RPSB;

            //tratativa de datas
            // response.data_inspecao = response.data_inspecao;
            response.data_dce = response.data_dce?.split(' ')[0];
            response.periodo_referencia = response.periodo_referencia.split(' ')[0];

            reset(response);
            setLoading(false);
        }
    }

    const proximoStep = handleSubmit(() => {
        setStepAtivo(prev => prev + 1);
    });

    const voltaStep = () => {
        setStepAtivo(prev => prev - 1);
    };

    const handleRecomendacoesChange = (recomendacoes: any) => {
        setValue('recomendacoes', recomendacoes, { shouldValidate: true });
    };

    return (
        <LayoutBase
            title='RPSB'
            tollBar={<ToolsDamInformation />}
        >
            {loading === true && (
                <div style={{ padding: 10 }}>
                    <LinearProgress />
                </div>
            )}

            {loading === false && (

                <Box>
                    <Box>
                        <Box style={{ marginTop: 2, display: 'flex', justifyContent: 'space-between' }}>
                            {stepAtivo > 0 ? (
                                <IconButton onClick={voltaStep}>
                                    <ArrowCircleLeft sx={{ height: 35, width: 35 }} />
                                </IconButton>
                            ) : (<Box style={{ height: 45, width: 60 }} />)}
                            <Box style={{ width: '100%' }}>
                                <Stepper activeStep={stepAtivo} alternativeLabel>
                                    {steps.map((label) =>
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    )}
                                </Stepper>
                            </Box>
                            {stepAtivo < 4 && (
                                <IconButton type='submit' form='step-form'>
                                    <ArrowCircleRight sx={{ height: 40, width: 40 }} />
                                </IconButton>
                            )}
                            {stepAtivo == 4 && (
                                <IconButton onClick={handleSubmit(handleSend)}>
                                    <SaveRounded />
                                </IconButton>
                            )}
                        </Box>
                    </Box>

                    {/* Formulario */}
                    <form id='step-form' onSubmit={proximoStep}>
                        {stepAtivo == 0 && (
                            <Box>
                                <Typography variant='h5'>Geral</Typography>
                                <Divider />
                                <Box style={{ display: 'grid', gridTemplateColumns: 'auto auto', marginTop: 5, padding: 10, gap: 10 }}>
                                    <TextField
                                        label='Período de referência'
                                        fullWidth
                                        type='date'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.periodo_referencia}
                                        helperText={formState.errors.periodo_referencia && 'Campo obrigatório'}
                                        {...register('periodo_referencia', { required: true })}
                                    />
                                    <TextField
                                        label='Empresa executora'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.empresa_executora}
                                        helperText={formState.errors.empresa_executora && 'Campo obrigatório'}
                                        {...register('empresa_executora', { required: true })}
                                    />
                                    <TextField
                                        label='Data de inspeção'
                                        fullWidth
                                        type='datetime-local'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.data_inspecao}
                                        helperText={formState.errors.data_inspecao && 'Campo obrigatório'}
                                        {...register('data_inspecao', { required: true })}
                                    />
                                    {/* <TextField
                                    label='Hora de inspeção'
                                    fullWidth
                                    type='time'
                                    InputLabelProps={{ shrink: true }}
                                    error={!!formState.errors.hora_inspecao}
                                    helperText={formState.errors.hora_inspecao && 'Campo obrigatório'}
                                    {...register('hora_inspecao', { required: true })}
                                /> */}
                                    <TextField
                                        label='Data DCE'
                                        fullWidth
                                        type='date'
                                        InputLabelProps={{ shrink: true }}
                                        {...register('data_dce', { required: false })}
                                    />
                                    <TextField
                                        label='Status DCE'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        {...register('status_dce', { required: false })}
                                    />
                                    <TextField
                                        label='Responsavel técnico'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.responsavel}
                                        helperText={formState.errors.responsavel && 'Campo obrigatório'}
                                        {...register('responsavel', { required: true })}
                                    />
                                    <TextField
                                        label='ART (número)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.art}
                                        helperText={formState.errors.art && 'Campo obrigatório'}
                                        {...register('art', { required: true })}
                                    />
                                    <TextField
                                        label='Órgão fiscalizador'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.orgao}
                                        helperText={formState.errors.orgao && 'Campo obrigatório'}
                                        {...register('orgao', { required: true })}
                                    />
                                    <TextField
                                        label='Dano pontecial associado (DPA)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.dpa}
                                        helperText={formState.errors.dpa && 'Campo obrigatório'}
                                        {...register('dpa', { required: true })}
                                    />
                                    <TextField
                                        label='Categoria de risco (CRI)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.cri}
                                        helperText={formState.errors.cri && 'Campo obrigatório'}
                                        {...register('cri', { required: true })}
                                    />
                                    <TextField
                                        label='Classificação (conforme órgão fiscalizador)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.classificacao}
                                        helperText={formState.errors.classificacao && 'Campo obrigatório'}
                                        {...register('classificacao', { required: true })}
                                    />
                                </Box>
                            </Box>
                        )}
                    </form>

                    {stepAtivo === 1 && (
                        <form id='form-analise' onSubmit={proximoStep}>
                            <Box>
                                <Typography variant='h5'>Análise de estabilidade</Typography>
                                <Divider />

                                {/* Campos simples */}
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'auto auto',
                                    mt: 2,
                                    p: 2,
                                    gap: 2
                                }}>
                                    <TextField
                                        label='Modos de falha considerados'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.analiseEstabilidade?.modos_falha}
                                        helperText={formState.errors.analiseEstabilidade?.modos_falha && 'Campo obrigatório'}
                                        {...register('analiseEstabilidade.modos_falha', { required: true })}
                                    />

                                    <TextField
                                        label='Método de análise (principal)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.analiseEstabilidade?.metodo_analise}
                                        helperText={formState.errors.analiseEstabilidade?.metodo_analise && 'Campo obrigatório'}
                                        {...register('analiseEstabilidade.metodo_analise', { required: true })}
                                    />
                                </Box>

                                <Typography variant='h5' sx={{ mt: 4 }}>Materiais e parâmetros</Typography>
                                <Divider />

                                <Button
                                    variant='contained'
                                    sx={{ mt: 2 }}
                                    onClick={() =>
                                        append({
                                            secao: '',
                                            condicao: '',
                                            fator_seguranca: '',
                                            valor_referencia: ''
                                        })}
                                    startIcon={<Add />}
                                >
                                    Adicionar material
                                </Button>

                                {fields.map((item, index) => (
                                    <Box key={item.id} sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                                        <TextField
                                            label='Seção'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={!!formState.errors.analiseEstabilidade?.informacoes?.[index]?.secao}
                                            helperText={formState.errors.analiseEstabilidade?.informacoes?.[index]?.secao && 'Campo obrigatório'}
                                            {...register(`analiseEstabilidade.informacoes.${index}.secao`, { required: true })}
                                        />
                                        <TextField
                                            label='Condição'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={!!formState.errors.analiseEstabilidade?.informacoes?.[index]?.condicao}
                                            helperText={formState.errors.analiseEstabilidade?.informacoes?.[index]?.condicao && 'Campo obrigatório'}
                                            {...register(`analiseEstabilidade.informacoes.${index}.condicao`, { required: true })}
                                        />
                                        <TextField
                                            label='Fator de segurança'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...register(`analiseEstabilidade.informacoes.${index}.fator_seguranca`)}
                                        />
                                        <TextField
                                            label='Valor de referência'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...register(`analiseEstabilidade.informacoes.${index}.valor_referencia`)}
                                        />
                                        <Button color='error' sx={{ gridColumn: '1 / -1' }} onClick={() => remove(index)} startIcon={<Remove />}>
                                            Remover item
                                        </Button>
                                    </Box>
                                ))}

                            </Box>
                        </form>
                    )}

                    <form id='step-verify' onSubmit={proximoStep}>
                        {stepAtivo == 2 && (
                            <Box>
                                <Typography variant='h5'>Verificação hidrológica/hidráulica</Typography>
                                <Divider />
                                <Box style={{ display: 'grid', gridTemplateColumns: 'auto auto', marginTop: 5, padding: 10, gap: 10 }}>
                                    <TextField
                                        label='Área de drenagem (km)²'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.area_drenagem}
                                        helperText={formState.errors.verificacaoHidrologica?.area_drenagem && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.area_drenagem', { required: true })}
                                    />
                                    <TextField
                                        label='Precipitação TR 10.000 ou PMP'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.precipitacao_pmp}
                                        helperText={formState.errors.verificacaoHidrologica?.precipitacao_pmp && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.precipitacao_pmp', { required: true })}
                                    />
                                    <TextField
                                        label='Precipitação do projeto (mm)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.precipitacao_projeto}
                                        helperText={formState.errors.verificacaoHidrologica?.precipitacao_projeto && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.precipitacao_projeto', { required: true })}
                                    />
                                    <TextField
                                        label='Duração crítica da chuva de projeto (min)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.duracao_chuva}
                                        helperText={formState.errors.verificacaoHidrologica?.duracao_chuva && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.duracao_chuva', { required: true })}
                                    />
                                    <TextField
                                        label='Vazão máxima afluente (m³/s)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.vazao_maxima}
                                        helperText={formState.errors.verificacaoHidrologica?.vazao_maxima && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.vazao_maxima', { required: true })}
                                    />
                                    <TextField
                                        label='NA máximo operacional (m)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.na_maximo_operacional}
                                        helperText={formState.errors.verificacaoHidrologica?.na_maximo_operacional && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.na_maximo_operacional', { required: true })}
                                    />
                                    <TextField
                                        label='NA máximo maximorum (m)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.na_maximo_maximorum}
                                        helperText={formState.errors.verificacaoHidrologica?.na_maximo_maximorum && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.na_maximo_maximorum', { required: true })}
                                    />
                                    <TextField
                                        label='Borda livre (m)'
                                        fullWidth
                                        type='number'
                                        InputLabelProps={{ shrink: true }}
                                        error={!!formState.errors.verificacaoHidrologica?.borda_livre}
                                        helperText={formState.errors.verificacaoHidrologica?.borda_livre && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.borda_livre', { required: true })}
                                    />
                                    <TextField
                                        label='Sistema de bombeamento (quantidade e capacidade)'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        type='number'
                                        error={!!formState.errors.verificacaoHidrologica?.bombeamento}
                                        helperText={formState.errors.verificacaoHidrologica?.bombeamento && 'Campo obrigatório'}
                                        {...register('verificacaoHidrologica.bombeamento', { required: false })}
                                    />
                                </Box>
                            </Box>
                        )}

                    </form>

                    {stepAtivo === 3 && (
                        <Recomendacoes
                            uuid_barregem={id ? id : ''}
                            data_inspecao={getValues('data_inspecao')}
                            changeRecomendacoes={handleRecomendacoesChange}
                            data={getValues('recomendacoes')}
                            editPlano={rpsb == 'new' ? false : true}
                        />
                    )}

                    {stepAtivo === 4 && (
                        <form id='form-avaliacao' onSubmit={proximoStep}>
                            <Box>
                                <Typography variant='h5'>Avaliação de aderência</Typography>
                                <Divider />

                                <Button variant='contained' sx={{ mt: 2 }} onClick={() => appendAvaliacao({ estudo: '', destaques: '' })}
                                    startIcon={<Add />}
                                >
                                    Adicionar
                                </Button>

                                {avaliacoesFields.map((item, index) => (
                                    <Box
                                        key={item.id}
                                        sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}
                                    >
                                        <TextField
                                            label='Estudo'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...register(`avaliacoes.${index}.estudo`, { required: true })}
                                        />
                                        <TextField
                                            label='Destaques'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...register(`avaliacoes.${index}.destaques`, { required: true })}
                                        />

                                        <Button
                                            color='error'
                                            sx={{ gridColumn: '1 / -1' }}
                                            onClick={() => removeAvaliacao(index)}
                                            startIcon={<Remove />}
                                        >
                                            Remover item
                                        </Button>
                                    </Box>
                                ))}

                            </Box>
                        </form>
                    )}
                </Box>
            )}
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                    key={alertInfo.message}
                />
            }
        </LayoutBase>
    );
}